var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.offerTemplatePart.type_id != 5
    ? _c("div", { staticClass: "offer-pdf-prev__text-item" }, [
        _c(
          "div",
          { staticClass: "offer-pdf-prev__del" },
          [
            _c("el-button", {
              attrs: { type: "danger", icon: "el-icon-delete" },
              on: {
                click: function($event) {
                  return _vm.$emit("deleteElement", _vm.offerTemplatePart.id)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.offerTemplatePart.headline
          ? _c("h2", {
              domProps: { innerHTML: _vm._s(_vm.offerTemplatePart.headline) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.offerTemplatePart.template) }
        })
      ])
    : _c(
        "div",
        {
          staticClass:
            "offer-pdf-prev__text-item offer-pdf-prev__text-item--price"
        },
        [
          _c(
            "div",
            { staticClass: "offer-pdf-prev__del" },
            [
              _c("el-button", {
                attrs: { type: "danger", icon: "el-icon-delete" },
                on: {
                  click: function($event) {
                    return _vm.$emit("deleteElement", _vm.offerTemplatePart.id)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.offerTemplatePart.headline
            ? _c("h2", {
                domProps: { innerHTML: _vm._s(_vm.offerTemplatePart.headline) }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            domProps: {
              innerHTML: _vm._s(_vm.offerTemplatePart.template_short)
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-4" }, [
              _vm._v("Unsere Servicepakete")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [_vm._v("Basic")]),
                _vm._v(" "),
                _vm.priceArr.priceCols == 2 || _vm.priceArr.priceCols == 3
                  ? _c("div", { staticClass: "col" }, [_vm._v("Standard")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.priceArr.priceCols == 3
                  ? _c("div", { staticClass: "col" }, [_vm._v("Premium")])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.priceArr.texts, function(item) {
            return _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [_vm._v(_vm._s(item.name))]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _vm._v(_vm._s(item.price1))
                  ]),
                  _vm._v(" "),
                  _vm.priceArr.priceCols == 2 || _vm.priceArr.priceCols == 3
                    ? _c("div", { staticClass: "col" }, [
                        _vm._v(_vm._s(item.price2))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.priceArr.priceCols == 3
                    ? _c("div", { staticClass: "col" }, [
                        _vm._v(_vm._s(item.price3))
                      ])
                    : _vm._e()
                ])
              ])
            ])
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-4" }, [_vm._v("Preis in Prozent")]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _vm._v(_vm._s(_vm.priceArr.price1) + "%")
                ]),
                _vm._v(" "),
                _vm.priceArr.priceCols == 2 || _vm.priceArr.priceCols == 3
                  ? _c("div", { staticClass: "col" }, [
                      _vm._v(_vm._s(_vm.priceArr.price2) + "%")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.priceArr.priceCols == 3
                  ? _c("div", { staticClass: "col" }, [
                      _vm._v(_vm._s(_vm.priceArr.price3) + "%")
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }